/**
 * Created by harris on 17-2-20.
 */
import axios from 'axios'
import AppConfig from 'src/config'
import ksort from 'locutus/php/array/ksort'
import md5 from 'locutus/php/strings/md5'
import {NetworkException, ResponseException} from './Exception'

// post和get提交方式api接口列表
const apiMap = {
  post: {  // post请求
    WeixinAuth: 'WeixinAuth',  // 微信认证
    UserInComeList: 'UserInCome_Select',  // 收益明细
    UserSplitFee: 'UserSplitFee_Select',  // 提成明细
    UserListenList: 'UserListenList_Select',  // 我的收听
    UserQuestionList: 'UserQuestionList_Select',  // 我的提问
    AdBannerList: 'AdBannerList_Select',  // 首页banner图和帮助中心
    UserInfo: 'UserInfo_Select',  // 我的页面
    UserAsk: 'UserAsk_Insert',  // 用户提问
    UserListen: 'UserListen_Insert',  // 用户偷听
    UserLike: 'UserLike_Insert',  // 赞和取消赞
    IsLikeAnswer: 'IsLikeAnswer_Select',  // 是否赞过此答案
    DoctorAroundIndex: 'DoctorAroundIndex_Select',  // 活动首页
    PromotionList: 'PromotionList_Select',  // 活动列表
    PromotionDetail: 'PromotionDetail_Select',  // 活动详情
    QuestionList: 'QuestionList_Select',  // 问题列表
    QuestionDetail: 'QuestionDetail_Select',  // 问题详情
    getValidateCode: 'ValidateCode_Insert',
    checkValidateCode: 'ValidateCode_Check',
    changephoneValidateCode: 'ValidateChangePhoneCode_Check'
    
  },
  get: {  // get请求

  }
};
// 自定义配置创建一个新的 axios 实例【HTTP 请求】
const apiAxios = axios.create({
  baseURL: AppConfig.api.baseURL,  // api接口根路径
  timeout: 15000,  // 请求超时限制 单位：毫秒，15秒请求时间
  withCredentials: true,  // 请求凭证
  headers: {  // 发送请求头
    'Content-Type': 'application/json',
    'X-Requested-With': 'XMLHttpRequest'
  },
  responseType: 'json'  // 返回的数据格式
});

// 添加一个请求拦截器【在处理 then 或 catch 之前拦截请求】
apiAxios.interceptors.request.use(function (config) {
  if (DEBUG) {
    console.log(config);
  }
  let payloadKey = config.method.toLowerCase() !== 'post' ? 'params' : 'data',
    payload = Object.assign({
      _timestamp: parseInt(Date.now() / 1000, 10),
    }, AppConfig.api.payload, config[payloadKey]);

  ksort(payload);

  let signStr = Object.keys(payload).map(key => `${key}=${typeof payload[key] === 'object' ? JSON.stringify(payload[key]) : payload[key]}`).join("&") + `&appkey=${AppConfig.appKey}`,
    _sign = md5(signStr);
  if (DEBUG) {
    console.log(signStr, _sign);
  }
  config[payloadKey] = {
    _sign,
    signStr,
    ...payload
  };
  //console.log('config=======');
  //console.log(config);
  //console.log('config=======end');
  return config;
}, function (error) {
    //console.log('error=======');
    //console.log(error);
  return Promise.reject(new NetworkException(error));
});

//添加一个响应拦截器【在处理 then 或 catch 之前拦截响应】
apiAxios.interceptors.response.use(function (response) {
  let data = response.data;
  delete response.data;
  data._response = response;

  if (data.errcode == 0) {
    return data;
  } else {
    return Promise.reject(new ResponseException(data))
  }
  //console.log('response=====');
  //console.log(data);
}, function (error) {
  //console.log('error=======');
    //console.log(error);
  return Promise.reject(new NetworkException(error));
});


function createApiMethod(axiosInstance, configMap) {
  let result = {};

  Object.keys(configMap).forEach(method => {
    let dataIds = configMap[method];

    Object.keys(dataIds).forEach(name => {

      let _dataid = dataIds[name];

      result[name] = function (_param) {
        _param || (_param = {})
        let payload = {
          _dataid,
          _param
        };
        return axiosInstance({
          url: 'api',
          method,
          [method !== 'post' ? 'params' : 'data']: payload
        })
      }
    })
  });
  return result;
}

export default createApiMethod(apiAxios, apiMap);





// WEBPACK FOOTER //
// ./src/lib/Net.js